import { Injectable } from '@angular/core'
import { PlayCountApi } from './base'

@Injectable()
export class VideoPlayCountApi extends PlayCountApi{
  apiPath(resourceId: number, areaId = '') {
    return `videos/${resourceId}/play_counts/${areaId}`
  }
}



// WEBPACK FOOTER //
// ./src/apis/play-count/video.ts